// extracted by mini-css-extract-plugin
export default {"page":"PounceAgentDetail_page__32JpO","cardBleed":"PounceAgentDetail_cardBleed__QNblq","stateBox":"PounceAgentDetail_stateBox__a8xiI","retryBtn":"PounceAgentDetail_retryBtn__NSbFj"};